import { Component, OnInit, OnDestroy } from '@angular/core';
import { sweetAlert } from '../../../utils/swal';
import { StaffService } from '../staff-service/staff.service';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
@Component({
  selector: 'app-staff-main',
  templateUrl: './staff-main.component.html',
  styleUrls: ['./staff-main.component.css']
})
export class StaffMainComponent implements OnInit, OnDestroy {
  staffList = [];
  search;
  imageModalUrl;
  status = "active";

  constructor(
    private staffService: StaffService) {
  }

  ngOnInit() {
    this.getStaffList();
  }

  getStaffList() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if(data) {
          this.staffList = data;
        }
    }, err => {
      sweetAlert('Error', err, 'warning', 'OK');
    });
  }

  openImageModal(url) {
    this.imageModalUrl = url;
  }

  
ngOnDestroy(): void {
}
}
